import { useEffect } from 'react';

interface IProps {
  setComplete: (status: boolean) => void;
}
export const None = ({ setComplete }: IProps) => {
  useEffect(() => {
    setComplete(true);
  }, [setComplete]);

  return <></>;
};
